export default "__VITE_ASSET__OUYtVIE8__"